import {
  Box,
  Paper,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import {
  AppFormikDatePicker,
  AppFormikTextArea,
  AppFormikTextField,
} from 'shared/components/AppComponents';

interface AchievementFormProps {
  test: any;
}

const AssigmentForm: React.FC<AchievementFormProps> = () => {
  const theme = useTheme();
  const match = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Paper variant="outlined" className="achievement-form-content">
      <Typography variant="h6">Details & Assignment</Typography>
      <Stack direction={match ? 'column' : 'row'} spacing={2}>
        <Box className="basic-information-likelihood">
          <AppFormikTextField
            name="reporter_source"
            placeholder="Scanner name, researcher, bug-bounty, incident RCA, etc."
            outerLabel
            label="Reporter / Source"
          />
        </Box>
        <Box className="basic-information-impact">
          <AppFormikTextField
            name="owner_assignee"
            placeholder="Person or team responsible for mitigation"
            outerLabel
            label="Owner / Assignee*"
          />
        </Box>
      </Stack>
      <Stack direction={match ? 'column' : 'row'} spacing={2}>
        <Box className="basic-information-likelihood">
          <AppFormikTextField
            name="severity_score"
            placeholder="CVSS or AI-specific scoring"
            outerLabel
            type="number"
            label="Severity Score"
          />
        </Box>
        <Box className="basic-information-impact">
          <AppFormikDatePicker
            autoFocus
            name="target_remediation_date"
            InputProps={{
              name: 'trainingdate',
              'aria-labelledby': 'trainingdate-label',
              notched: false,
            }}
            label="Target Remediation Date"
            outerLabel
            placeholder="gg/mm/aaaa"
            renderInput={(props: any) => <TextField {...props} />}
            autoComplete="off"
            onEnter={() => {
              console.log('ripple');
            }}
          />
        </Box>
      </Stack>
      <Box className="basic-information-description">
        <AppFormikTextArea
          name="exploitability_details"
          placeholder="Proof-of-concept, attack vector, prerequisites"
          label="Exploitability Details"
          outerLabel
          rows={4}
        />
      </Box>
      <Box className="basic-information-description">
        <AppFormikTextArea
          name="business_impact"
          placeholder="Potential GDPR/CCPA breach, safety, fairness, IP loss"
          label="Business / Regulatory Impact"
          outerLabel
          rows={4}
        />
      </Box>
    </Paper>
  );
};

export default AssigmentForm;
